import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getElectricPriceRule, getElectricBasicsPrice } from '@/service/operate/energyManagement';
export default function useElectricPrice(params) {
  var priceRule = ref([]);
  // const basePrice = ref<IElectricBasicPrice>({
  //   electric_capacity: 0,
  //   electric_price: 0,
  //   tot_electirc_price: 0
  // });
  var basePrice = ref({
    electric_capacity: 0,
    electric_price: 0,
    tot_electirc_price: 0
  });
  // 获取主机汇总数据
  var getElectricPriceRuleAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getElectricPriceRule({
              date: params.value.date
            });
          case 2:
            data = _context.sent;
            priceRule.value = data.list;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getElectricPriceRuleAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var getElectricBasicsPriceAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getElectricBasicsPrice();
          case 2:
            data = _context2.sent;
            basePrice.value = data;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getElectricBasicsPriceAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [priceRule, basePrice, getElectricPriceRuleAsync, getElectricBasicsPriceAsync];
}